import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ColorOptions, TextStyleOptions } from '@df/ui/atomic/atomic-options';
import { ToggleService } from '@df/ui/toggle/toggle.service';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';

export namespace NCmsAccordion {
    export const componentId = 'accordion';
    export interface IItem {
        title: string;
        components?: NICmsContentComponent.IData[];
    }

    export interface IComponentData extends NICmsContentComponent.IData {
        items: IItem[];
        borderColor?: string;
        titleFont?: string;
    }
}

let uid = 0;

@ICmsComponent<CmsAccordionComponent>({
    id: NCmsAccordion.componentId,
    name: 'Accordion',
    tags: ['text', 'textarea'],
    isAdvanced: true,
    fields: [
        <NICmsContentField.IChoiceField>{
            key: 'titleFont',
            type: NICmsContentField.EFieldType.choice,
            title: 'Title style',
            options: TextStyleOptions,
            default: 'h3'
        },
        <NICmsContentField.IChoiceField>{
            key: 'borderColor',
            type: NICmsContentField.EFieldType.choice,
            title: 'Border color',
            options: ColorOptions,
            colorPreview: true,
            default: 'col-4'
        },
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'items',
            title: 'Item',
            itemName: 'Item',
            itemNameField: 'title',
            defaultSize: 1,
            required: true,
            fields: [
                {
                    key: 'title',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Title',
                    default: 'Title',
                    required: true
                },
                <NICmsContentField.IComponentsField>{
                    key: 'components',
                    type: NICmsContentField.EFieldType.components,
                    title: 'Content components',
                    itemName: 'component',
                    default: []
                }
            ],
            default: [
                { title: 'Accordion title', components: [] },
                { title: 'Second title', components: [] }
            ]
        }
    ]
})
@Component({
    selector: 'cms-accordion',
    templateUrl: './cms-accordion.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsAccordionComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NCmsAccordion.IComponentData;

    readonly toggleGroupId = `cmsAccordion${uid++}`;

    constructor(protected toggleService: ToggleService) {
        super();
    }
}
